
import Shimmer from "@/components/ui/shimmer";

export const WorkoutShimmer = () => {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center p-6 transition-colors duration-300">
      <Shimmer className="h-8 w-64 mb-8" />
      <div className="w-full max-w-md space-y-8">
        <div className="text-center space-y-4">
          <Shimmer className="h-16 w-16 mx-auto rounded-full" />
          <div className="flex justify-center gap-8">
            <div className="space-y-2">
              <Shimmer className="h-4 w-20" />
              <Shimmer className="h-8 w-12" />
            </div>
            <div className="space-y-2">
              <Shimmer className="h-4 w-20" />
              <Shimmer className="h-8 w-12" />
            </div>
          </div>
          <Shimmer className="h-12 w-full rounded-xl mt-4" />
          <div className="flex gap-1 mt-4">
            {[...Array(4)].map((_, i) => (
              <Shimmer key={i} className="h-2 flex-1 rounded-full" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
